<!--=============================
=            SELECTS            =
==============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Selects</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground Selects</div>
          <div slot="card-body">
            <div>
              <playground-selects></playground-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Disable</div>
          <div slot="card-body">
            <div>
              <disabled-selects></disabled-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Ready Only</div>
          <div slot="card-body">
            <div>
              <readonly-selects></readonly-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Light Theme</div>
          <div slot="card-body">
            <div>
              <lighttheme-selects></lighttheme-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Icons</div>
          <div slot="card-body">
            <div>
              <icons-selects></icons-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple</div>
          <div slot="card-body">
            <div>
              <multiple-selects></multiple-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <div>
              <dense-selects></dense-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Customized</div>
          <div slot="card-body">
            <div>
              <customized-selects></customized-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Change Selects</div>
          <div slot="card-body">
            <div>
              <change-selects></change-selects>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ChangeSelects from "../../components/Forms/Selects/ChangeSelects.vue";
import CustomizedSelects from "../../components/Forms/Selects/CustomizedSelects.vue";
import DenseSelects from "../../components/Forms/Selects/DenseSelects.vue";
import DisabledSelects from "../../components/Forms/Selects/DisabledSelects.vue";

import IconsSelects from "../../components/Forms/Selects/IconsSelects.vue";
import LightthemeSelects from "../../components/Forms/Selects/LightthemeSelects.vue";
import MultipleSelects from "../../components/Forms/Selects/MultipleSelects.vue";
import PlaygroundSelects from "../../components/Forms/Selects/PlaygroundSelects.vue";
import ReadonlySelects from "../../components/Forms/Selects/ReadonlySelects.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    ChangeSelects,
    CustomizedSelects,
    DenseSelects,
    DisabledSelects,
    IconsSelects,
    LightthemeSelects,
    MultipleSelects,
    PlaygroundSelects,
    ReadonlySelects
  }
};
</script>

<!--====  End of SELECTS  ====-->
